export default __webpack_public_path__ + "static/media/PublicSans-Bold.fb153667.ttf";